export default function ({ prettyBullets, items, _editable, _uid }) {
  return {
    _editable,
    _uid,
    module: 'SList',
    prettyBullets: prettyBullets,
    items: items.split(',\n')
  };
}
